// extracted by mini-css-extract-plugin
export default {"container":"Additem_container__nZVoP","corner_button":"Additem_corner_button__lBPBN"};